

import { Download } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { useDownloadImage } from '@/components/react-flow/hooks/useDownloadImage';

/**
 * Download button that exports the flow graph as PNG
 */
export function DownloadGraphButton() {
  const { downloadImage, isDownloading } = useDownloadImage({
    defaultFileName: 'narrative-structure',
    backgroundColor: '#f0f4f8',
  });

  return (
    <Tooltip title="Download as PNG">
      <IconButton
        size="small"
        onClick={() => downloadImage()}
        disabled={isDownloading}
        sx={{
          bgcolor: 'white',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          '&:hover': { bgcolor: 'grey.50' },
        }}
      >
        <Download sx={{ fontSize: 18 }} />
      </IconButton>
    </Tooltip>
  );
}

export default DownloadGraphButton;
